module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av520-c1710bdfa04964a384f4562f72f71d85.jpg";